/* sg-pdp-together: relaciona productos para «Se ven perfecto juntos».
   1) Mismo modelo (etiqueta Mod:) pero de OTRO tipo: buró + su cabecera, cómoda, espejo...
   2) Si faltan, combinaciones por tipo (tabla de ajustes) preferiendo el mismo estilo (etiquetas Attr:).
   3) Si no hay nada, se queda lo que el servidor ya pintó (misma colección).
   Las tarjetas llegan ya armadas por la vista «?view=cards» (templates/collection.cards.liquid): una sola petición por colección. */
(() => {
  const CARD_SELECTOR = 'li[data-product-id]';

  const init = (root) => {
    if (!root || root.dataset.sgReady) return;
    root.dataset.sgReady = '1';
    const grid = root.querySelector('[data-sg-together-grid]');
    if (!grid) return;

    const cfg = {
      base: (root.dataset.root || '/').replace(/\/?$/, '/'),
      view: root.dataset.view || 'cards',
      self: root.dataset.self || '',
      type: root.dataset.type || '',
      catalog: root.dataset.catalog || 'all',
      model: root.dataset.model || '',
      styles: (root.dataset.styles || '').split('+').filter(Boolean),
      catPrefix: root.dataset.catPrefix || 'cat-',
      cats: (root.dataset.cats || '').split(',').filter(Boolean),
      pairings: (root.dataset.pairings || '').split(',').map((h) => h.trim()).filter(Boolean),
      limit: parseInt(root.dataset.limit, 10) || 4,
      fill: root.dataset.fill !== 'false',
    };

    /* Una colección (con filtro de etiquetas en la URL) → lista de <li> con tarjetas */
    const fetchCards = async (handle, tags) => {
      const path = `collections/${handle}${tags && tags.length ? `/${tags.join('+')}` : ''}`;
      try {
        const res = await fetch(`${cfg.base}${path}?view=${cfg.view}`, { headers: { Accept: 'text/html' } });
        if (!res.ok) return [];
        const tpl = document.createElement('template');
        tpl.innerHTML = await res.text();
        return [...tpl.content.querySelectorAll(CARD_SELECTOR)];
      } catch (err) {
        return [];
      }
    };

    /* Estilo primero con todas las etiquetas, luego solo con la primera, luego sin filtro */
    const fetchStyled = async (handle) => {
      const attempts = cfg.styles.length > 1 ? [cfg.styles, cfg.styles.slice(0, 1), []] : cfg.styles.length === 1 ? [cfg.styles, []] : [[]];
      for (const tags of attempts) {
        // eslint-disable-next-line no-await-in-loop
        const items = await fetchCards(handle, tags);
        if (items.length) return items;
      }
      return [];
    };

    /* Reparte por tipo: primero uno de cada tipo, luego el segundo de cada tipo, etc. */
    const roundRobin = (groups, room, taken) => {
      const out = [];
      const queues = groups.map((g) => g.filter((li) => !taken.has(li.dataset.productId)));
      let round = 0;
      while (out.length < room && queues.some((q) => q.length > round)) {
        for (const q of queues) {
          const li = q[round];
          if (li && out.length < room && !taken.has(li.dataset.productId)) {
            taken.add(li.dataset.productId);
            out.push(li);
          }
        }
        round += 1;
      }
      return out;
    };

    /* Categorías compartidas con el producto actual (p. ej. cat-recamaras): más en común = más relacionado */
    const score = (li) => {
      const tags = (li.dataset.tags || '').split(',');
      return cfg.cats.filter((c) => tags.includes(c)).length;
    };

    /* Los tipos se ordenan por su mejor puntuación; dentro de cada tipo, por puntuación */
    const byType = (items) => {
      items = items.slice().sort((a, b) => score(b) - score(a));
      const map = new Map();
      items.forEach((li) => {
        const t = li.dataset.type || '';
        if (!map.has(t)) map.set(t, []);
        map.get(t).push(li);
      });
      return [...map.values()];
    };

    const run = async () => {
      const taken = new Set([cfg.self]);
      let picked = [];

      /* 1) Mismo modelo, de otro tipo. Los que comparten categoría van primero; los de otra categoría (p. ej. un banco para un buró) quedan de reserva */
      let reserve = [];
      if (cfg.model) {
        const siblings = (await fetchCards(cfg.catalog, [cfg.model])).filter((li) => li.dataset.productId !== cfg.self && li.dataset.type !== cfg.type);
        const related = cfg.cats.length ? siblings.filter((li) => score(li) > 0) : siblings;
        reserve = cfg.cats.length ? siblings.filter((li) => score(li) === 0) : [];
        picked = roundRobin(byType(related), cfg.limit, taken);
      }

      /* 2) Combinaciones por tipo, si faltan */
      if (cfg.fill && picked.length < cfg.limit && cfg.pairings.length) {
        const lists = await Promise.all(cfg.pairings.map((h) => fetchStyled(h)));
        const groups = lists.map((l) => l.filter((li) => li.dataset.productId !== cfg.self));
        picked = picked.concat(roundRobin(groups, cfg.limit - picked.length, taken));
      }

      /* 3) Si aún faltan, los hermanos de otra categoría */
      if (picked.length < cfg.limit && reserve.length) picked = picked.concat(roundRobin(byType(reserve), cfg.limit - picked.length, taken));

      if (!picked.length) return; // sin resultados: se queda el respaldo del servidor
      grid.replaceChildren(...picked);
      root.dataset.sgSource = 'smart';
    };

    grid.setAttribute('aria-busy', 'true');
    run().finally(() => grid.removeAttribute('aria-busy'));
  };

  const boot = () => document.querySelectorAll('[data-sg-together]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
